import { contactContent } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">联系我们</h2>
          <p className="mt-2 text-sm text-foreground-500">投稿、合作与咨询</p>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8">
            {contactContent.description}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-lg text-accent-600"></i>
              </div>
              <div className="min-w-0">
                <p className="text-xs text-foreground-400">电子邮箱</p>
                <p className="text-sm font-medium text-foreground-900 truncate">{contactContent.email}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50">
              <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-lg text-secondary-700"></i>
              </div>
              <div className="min-w-0">
                <p className="text-xs text-foreground-400">微信</p>
                <p className="text-sm font-medium text-foreground-900">{contactContent.wechat}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-chat-1-line text-lg text-primary-600"></i>
              </div>
              <div className="min-w-0">
                <p className="text-xs text-foreground-400">QQ群</p>
                <p className="text-sm font-medium text-foreground-900">{contactContent.qq}</p>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-background-200/70 text-center">
            <p className="text-xs text-foreground-400">工作时间：周一至周日 9:00 - 21:00</p>
          </div>
        </div>
      </div>
    </section>
  );
}